"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legal = void 0;
exports.legal = {
    approval_date: '2000-01-01T00:00:00.000Z',
    date_of_birth: '2000-01-01T00:00:00.000Z',
    first_name: 'Test',
    gender: 'male',
    last_name: 'Person',
    middle_name: null,
    suffix: null
};
